export enum PermissionSource {
  SYSTEM_SETTINGS = 'systemSettings',
  USER_DATA = 'userData',
  USER_PROJECT_PERMISSIONS = 'userProjectPermissions',
}
